import { Component, inject } from '@angular/core';

import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [],
  template: `
    @if (toastService.pendingConfirm(); as confirm) {
      <div class="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]" (click)="cancel()">
        <div class="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6" (click)="$event.stopPropagation()">
          <h3 class="text-lg font-semibold text-neutral-900 mb-2">{{ confirm.title }}</h3>
          <p class="text-sm text-neutral-600 mb-6">{{ confirm.message }}</p>
          <div class="flex justify-end gap-3">
            <button class="sz-btn-outline" (click)="cancel()">Cancel</button>
            <button class="sz-btn-primary" (click)="ok()">Confirm</button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConfirmDialogComponent {
  readonly toastService = inject(ToastService);

  ok() {
    this.toastService.resolveConfirm(true);
  }

  cancel() {
    this.toastService.resolveConfirm(false);
  }
}
